import { useRef, useEffect } from "react";
import { Bold, Italic, List, Quote, Link2, Heading2, Heading3, Pilcrow, RemoveFormatting } from "lucide-react";

const BTNS = [
  { icon: Pilcrow, label: "Paragraph", cmd: "formatBlock", arg: "p", id: "rte-paragraph" },
  { icon: Heading2, label: "Heading 2", cmd: "formatBlock", arg: "h2", id: "rte-h2" },
  { icon: Heading3, label: "Heading 3", cmd: "formatBlock", arg: "h3", id: "rte-h3" },
  { icon: Bold, label: "Bold", cmd: "bold", id: "rte-bold" },
  { icon: Italic, label: "Italic", cmd: "italic", id: "rte-italic" },
  { icon: Quote, label: "Quote", cmd: "formatBlock", arg: "blockquote", id: "rte-quote" },
  { icon: List, label: "List", cmd: "insertUnorderedList", id: "rte-list" },
];

export default function RichTextEditor({ value, onChange, testid = "rich-text-editor" }) {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current && ref.current.innerHTML !== (value || "")) {
      ref.current.innerHTML = value || "";
    }
  }, [value]);
  const exec = (cmd, arg) => {
    ref.current?.focus();
    document.execCommand(cmd, false, arg);
    onChange(ref.current.innerHTML);
  };

  const addLink = () => {
    const url = window.prompt("Link URL", "https://");
    if (url) exec("createLink", url);
  };

  return (
    <div className="overflow-hidden rounded-xl border border-white/10 bg-white/[0.02]">
      <div className="flex flex-wrap items-center gap-1 border-b border-white/10 bg-white/[0.03] p-2">
        {BTNS.map((b) => (
          <button
            key={b.id}
            type="button"
            title={b.label}
            aria-label={b.label}
            data-testid={b.id}
            onMouseDown={(e) => {
              e.preventDefault();
              exec(b.cmd, b.arg);
            }}
            className="flex h-8 w-8 items-center justify-center rounded-lg text-neutral-400 transition-colors hover:bg-white/10 hover:text-white"
          >
            <b.icon className="h-4 w-4" />
          </button>
        ))}
        <button
          type="button"
          title="Link"
          aria-label="Link"
          data-testid="rte-link"
          onMouseDown={(e) => {
            e.preventDefault();
            addLink();
          }}
          className="flex h-8 w-8 items-center justify-center rounded-lg text-neutral-400 transition-colors hover:bg-white/10 hover:text-white"
        >
          <Link2 className="h-4 w-4" />
        </button>
        <button
          type="button"
          title="Clear formatting"
          aria-label="Clear formatting"
          data-testid="rte-clear"
          onMouseDown={(e) => {
            e.preventDefault();
            exec("removeFormat");
          }}
          className="flex h-8 w-8 items-center justify-center rounded-lg text-neutral-400 transition-colors hover:bg-white/10 hover:text-white"
        >
          <RemoveFormatting className="h-4 w-4" />
        </button>
      </div>
      <div
        ref={ref}
        contentEditable
        suppressContentEditableWarning
        onInput={() => onChange(ref.current.innerHTML)}
        className="rich-text min-h-[220px] px-5 py-4 outline-none"
        data-testid={testid}
      />
    </div>
  );
}
